import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { FIREBASE_CONFIG } from '../config';

// Khởi tạo Firebase app nếu chưa có
let app;
if (getApps().length === 0) {
  app = initializeApp(FIREBASE_CONFIG);
} else {
  app = getApps()[0];
}

// Khởi tạo và export Firebase Auth
export const auth = getAuth(app);

// Export app nếu cần
export default app;

